
export default {
    title: '灌浆施工智能监测系统',
    baseUrl: {
        dev: 'http://192.168.1.105:8089',
        pro: 'https://service.dy-gj.cn/'
    },
    uploadAction: '/api/admin/upload',
    imgServer: 'https://grouting-1318074248.cos.ap-nanjing.myqcloud.com',
}
